import { render, staticRenderFns } from "./FileData.vue?vue&type=template&id=321c0d19&scoped=true&"
import script from "./FileData.vue?vue&type=script&lang=js&"
export * from "./FileData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c0d19",
  null
  
)

export default component.exports